module.exports = __webpack_public_path__ + "assets/img/icon-badge-baf806d9.png";